var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Loader, Popover } from '../..';
import { CastedScreenInfoStyled, Styled } from './style';
export var CastedScreenInfoActions;
(function (CastedScreenInfoActions) {
    CastedScreenInfoActions["NAVIGATE_SCREEN"] = "NAVIGATE_SCREEN";
    CastedScreenInfoActions["NAVIGATE_DEVICE"] = "NAVIGATE_DEVICE";
    CastedScreenInfoActions["STOP_CAST"] = "STOP_CAST";
})(CastedScreenInfoActions || (CastedScreenInfoActions = {}));
var CastedScreenInfo = /** @class */ (function (_super) {
    __extends(CastedScreenInfo, _super);
    function CastedScreenInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            screens: props.screens,
            screenUpdatingList: [],
        };
        return _this;
    }
    CastedScreenInfo.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.screens !== prevState.screens) {
            return { screens: nextProps.screens };
        }
        return null;
    };
    CastedScreenInfo.prototype.componentDidUpdate = function (prevProps) {
        var screenUpdatingList = this.state.screenUpdatingList;
        // remove screenUpdatingList ids if it no longer existed in screens
        if (prevProps.screens !== this.props.screens) {
            if (screenUpdatingList.length) {
                var screenIds_1 = this.props.screens.map(function (s) { return s.screenId; });
                screenUpdatingList = screenUpdatingList.filter(function (v) { return screenIds_1.includes(v); });
                if (screenUpdatingList.length) {
                    this.setState({ screenUpdatingList: screenUpdatingList });
                }
            }
        }
    };
    CastedScreenInfo.prototype.componentWillUnmount = function () {
        this.setState({
            screenUpdatingList: [],
        });
    };
    CastedScreenInfo.prototype.handleCallback = function (data, action) {
        if (action === CastedScreenInfoActions.STOP_CAST) {
            var screenUpdatingList = this.state.screenUpdatingList;
            screenUpdatingList.push(data);
            this.setState({ screenUpdatingList: screenUpdatingList });
        }
        return this.props.callBack && this.props.callBack(data, action);
    };
    CastedScreenInfo.prototype.render = function () {
        var _this = this;
        var _a = this.state, screens = _a.screens, screenUpdatingList = _a.screenUpdatingList;
        return (screens.length > 0 &&
            React.createElement(Popover, { inverted: true, className: "pop-modal", trigger: React.createElement(Styled, { className: "on-screen", title: "Casting on " + screens.length + " screen" + (screens.length > 1 ? 's' : '') },
                    React.createElement(Icon, { name: "screen-casting" }),
                    React.createElement("span", { className: "screen-count" }, screens.length)), on: "click", content: React.createElement(CastedScreenInfoStyled, null,
                    React.createElement("div", { className: "header" },
                        React.createElement(FormattedMessage, { id: "ui_component.common.currently_casting_on", defaultMessage: "Currently casting on ..." })),
                    screens.map(function (screen, index) { return (React.createElement("div", { className: "screen-item", key: "screen-" + index },
                        React.createElement("div", { className: "screen-alpha" },
                            React.createElement("h3", { title: screen.screenName, onClick: function () {
                                    _this.handleCallback(screen.screenId, CastedScreenInfoActions.NAVIGATE_SCREEN);
                                } }, screen.screenName),
                            React.createElement("span", { title: screen.deviceName || 'Unknown Device', onClick: function () {
                                    _this.handleCallback(screen.deviceId, CastedScreenInfoActions.NAVIGATE_DEVICE);
                                } }, screen.deviceName || 'Unknown Device')),
                        screenUpdatingList.indexOf(screen.screenId) > -1
                            ? React.createElement("div", { title: "stopping", className: "screen-pending" },
                                React.createElement(Loader, { inline: true, active: true, size: "mini" }))
                            : React.createElement("div", { title: "Stop casting", className: "screen-stop " + (screen.disabled ? 'disabled' : ''), onClick: function () {
                                    if (screen.disabled) {
                                        return;
                                    }
                                    else {
                                        _this.handleCallback(screen.screenId, CastedScreenInfoActions.STOP_CAST);
                                    }
                                } },
                                React.createElement(Icon, { name: "stop" })))); })) }));
    };
    return CastedScreenInfo;
}(React.Component));
export default CastedScreenInfo;
//# sourceMappingURL=index.js.map